angular.
module('moebiusProadapt')

    .directive('mbsTimeline', ['$timeout', 'mbsEtiService', 'growl', '$http', '$filter', '$uibModal', '$window', function ($timeout, mbsEtiService, growl, $http, $filter, $uibModal, $window) {
        function link(scope, element, attrs, $ctrl)
        {

            scope.$watchGroup(['participant.date_j0','participant.date_j0_modifie','participant.participantVisitesByVisiteKey'], function(){

                // -- icons timeline par status
                var constants_visite_status = scope.$parent.constants.visite_status.NAMES_TO_VALUES;
                scope.icons = {};
                scope.icons[constants_visite_status['SS__OPENED']]              = ['fas fa-play '];
                scope.icons[constants_visite_status['SS__START_RDV_PHYSIQUE']]   = ['far fa-calendar'];
                scope.icons[constants_visite_status['SS__END_RDV_PHYSIQUE']]     = ['fas fa-calendar-check'];
                // scope.icons[constants_visite_status['SS__REJECTED']] = 'fas fa-play ';
                scope.icons[constants_visite_status['SS__FINAL_APPROVED']] = ['fas fa-step-forward'];
                scope.icons[constants_visite_status['SS__START_QR_MOBILE']]     = ['fas fa-arrow-right','fa fa-mobile-alt'];
                scope.icons[constants_visite_status['SS__END_QR_MOBILE']]       = ['fa fa-mobile-alt', 'fas fa-arrow-right'];
                scope.icons[constants_visite_status['SS__NOT_APPLICABLE']]      =  ['fas fa-fast-forward'];

                // -- bouton de changement de status
                scope.buttonsChangeStatus = {};
                scope.buttonsChangeStatus[constants_visite_status['SS__OPENED']]               = {text: null};
                scope.buttonsChangeStatus[constants_visite_status['SS__START_RDV_PHYSIQUE']]   = {text: null};
                scope.buttonsChangeStatus[constants_visite_status['SS__END_RDV_PHYSIQUE']]     = {text: null};
                scope.buttonsChangeStatus[constants_visite_status['SS__START_QR_MOBILE']]      = {text: null};
                scope.buttonsChangeStatus[constants_visite_status['SS__END_QR_MOBILE']]        = {text: null};

                // -- est-ce que le participant travail avec anamnèse
                var isAnamnese      = false;
                var anamneseStatus  = [constants_visite_status['SS__START_QR_MOBILE'], constants_visite_status['SS__END_QR_MOBILE']];
                if ( scope.participant.status == scope.$parent.constants.participant_status.NAMES_TO_VALUES.creation_anamnese ) {
                    isAnamnese = true;
                }

                // -- ----------------------
                // -- Initialisation directive
                // -- ----------------------

                scope.visite                        = scope.etudedef.visitesList[scope.concernedVisiteKey];
                scope.visiteTransitionsOrdered      = [];
                scope.visiteTransitionsList         = {};


                // -- Filtrage hideInAction ET Anamnèse
                var transitionsToHideInActionOrAnamnese       = [];
                _.each(scope.etudedef.statusTransitionList[scope.concernedVisiteKey], function(visiteTransitionObj, k) {
                    // -- hide in action
                    if (visiteTransitionObj.hideInAction === true) {
                        transitionsToHideInActionOrAnamnese.push(visiteTransitionObj.visite_status_id);
                    }
                    // -- Anamnèse status, if the visite has anamnèse status, and the patient IS NOT anamnyse
                    else if (!isAnamnese && anamneseStatus.indexOf(visiteTransitionObj.visite_status_id) !== -1) {
                        transitionsToHideInActionOrAnamnese.push(visiteTransitionObj.visite_status_id);
                    }
                });
                // -- list filtrée des status id à présenter pour ce participant pour cette visite
                scope.visiteTransitionsOrdered      = _.difference(scope.etudedef.statusTransitionOrderedKeys[scope.concernedVisiteKey], transitionsToHideInActionOrAnamnese);

                // -- Création de scope.visiteTransitionsList et scope.stepNumber en fonction de ça
                _.each(scope.visiteTransitionsOrdered, function (visiteTransitionKey, k) {

                    scope.visiteTransitionsList[visiteTransitionKey] = scope.etudedef.statusTransitionList[scope.concernedVisiteKey][visiteTransitionKey];
                });

                scope.stepNumber                    = _.size(scope.visiteTransitionsList);

                // -- on fait moins 1 parce que le status rejected (décès) est : 1. Toujours présent, 2. jamais affiché dans la timeline
                scope.stepWidth                     = 100/(scope.stepNumber-1);

                scope.currentParticipantStatus      = scope.participant.participantVisitesByVisiteKey[scope.concernedVisiteKey].status;

                if (scope.participant.participantPlanningVisitesByVisiteKey) {
                    scope.currentParticipantPlanningsOfVisite    = scope.participant.participantPlanningVisitesByVisiteKey[scope.concernedVisiteKey];
                }


                // -- global timeline color
                // -- colored if current visite
                // -- black if past visite
                scope.class_past_visite             = (scope.concernedVisiteKey !== scope.participant.currentVisiteKey) ? 'past' : '';

                scope.timelineStructure = [];
                var bouton_change_status_actif    = null;
                var class_done_now_next_future    = 'done';
                var class_step                    = 'fa-check-circle';
                _.each(scope.visiteTransitionsOrdered, function(visiteStatusTransitionId) {

                    var statusTransition = scope.visiteTransitionsList[visiteStatusTransitionId];
                    var timelineItem = {};
                    timelineItem.statusTransition       = statusTransition;
                    timelineItem.bouton_change_status   = null;

                    if (scope.currentParticipantPlanningsOfVisite) {
                        timelineItem.participantPlanning = scope.currentParticipantPlanningsOfVisite[statusTransition.visite_status_id];
                    }

                    // -- icons du step
                    var icons_step_elements = '';
                    // -- on peut avoir plusieurs icône, d'où le parcours each
                    _.each(scope.icons[statusTransition.visite_status_id], function(classIcon) {
                        icons_step_elements += '<i class="'+classIcon+'"></i>'
                    });



                    if (scope.visiteTransitionsOrdered.indexOf(scope.currentParticipantStatus) < scope.visiteTransitionsOrdered.indexOf(statusTransition.visite_status_id)) {
                        // -- future or immediate next transition
                        // if (statusTransition.visite_status_id === constants_visite_status['SS__NOT_APPLICABLE']) {
                        //     class_done_now_next_future  = 'bypass';
                        // }
                        // else
                        if (scope.visiteTransitionsOrdered.indexOf(scope.currentParticipantStatus)+1 === scope.visiteTransitionsOrdered.indexOf(statusTransition.visite_status_id)) {
                            class_done_now_next_future  = 'next';
                        } else {
                            class_done_now_next_future  = 'future';
                        }
                        timelineItem.buttonsChangeStatus = {
                            text:  scope.$parent.constants.visite_status.VALUES_TO_DISPLAY_TODO[statusTransition.visite_status_id]
                        };
                        class_step = 'fa-circle-o';
                        if (!bouton_change_status_actif) {
                            bouton_change_status_actif        = scope.buttonsChangeStatus[statusTransition.visite_status_id];
                            timelineItem.bouton_change_status = bouton_change_status_actif;
                        }
                    } else {
                        // -- now (current status)
                        if (scope.visiteTransitionsOrdered.indexOf(scope.currentParticipantStatus) === scope.visiteTransitionsOrdered.indexOf(statusTransition.visite_status_id)) {
                            class_done_now_next_future  = 'now';

                            // Si notre status now est AVANT les status anamnèse, l'idxCountAnamneseStatus s'incrementera naturellement
                            // Sinon, pour le calcul du next, il faut le reinit à 0
                        }

                        timelineItem.buttonsChangeStatus = {
                            text:  scope.$parent.constants.visite_status.VALUES_TO_DISPLAY[statusTransition.visite_status_id]
                        };
                    }


                    timelineItem.class_done_now_next_future            = class_done_now_next_future;
                    timelineItem.class_step                      = class_step;
                    timelineItem.icons_step_elements             = icons_step_elements;

                    timelineItem.infobulle_step                  = scope.$parent.constants.visite_status.VALUES_TO_DISPLAY_DETAIL[statusTransition.visite_status_id];

                    scope.timelineStructure.push(timelineItem);
                });
            });
            // -- ----------------------
            // -- On Bootstrap
            // -- ----------------------

            scope.getContentUrl = function() {
                return 'assets/templates/etude/' + scope.templateFile
            };

        }

        return {
            restrict: 'E',
            scope: {

                todayDate:      '=todayDate',
                etudedef:       '=mbsEtudedef',
                participant:    '=mbsParticipant',
                templateFile:    '=mbsTemplateFile',
                concernedVisiteKey:       '=mbsVisiteKey',
                mbsOnClickStatusButton: "&"
            },
            link: link,
            template: '<div ng-include="getContentUrl()"></div>'
            // templateUrl: scope.getTemplateUrl(),
        }
    }])
;


// WEBPACK FOOTER //
// ./resources/assets/js/directives/timeline.js